const isDev = import.meta.env.DEV;

/** Dev-only logging; avoids noisy `console` usage in production builds. */
export const logger = {
  log: (...args: unknown[]) => {
    if (isDev) console.log(...args);
  },
  warn: (...args: unknown[]) => {
    if (isDev) console.warn(...args);
  },
  error: (...args: unknown[]) => {
    if (isDev) console.error(...args);
  }
};
